import _ from 'lodash';
import React, { useEffect, useState } from 'react';

import { CarouselNavigationContext } from '../InteractiveContent';
import { WidgetsContext } from './../core';
import Content from '../core/content';

export const Actions = React.createContext({

  onBeforeExecution: (widget, action) => {},
  onAfterExecution: (widget, action) => {}
});

export function useActionExectioner() {
  const context = React.useContext(Actions);
  const interactiveContext = React.useContext(CarouselNavigationContext);
  const widgetContext = React.useContext(WidgetsContext);
  const contentContext = React.useContext(Content.Context);

  const [state, setState] = useState({
    execute: (widget, action) => {}
  });

  useEffect(() => {
    setState({
      execute: handleExecution
    });

  }, [interactiveContext, widgetContext]);

  const handleBeforeExecution = (widget, action) => {
    if(context.onBeforeExecution){
      context.onBeforeExecution(widget, action);
    }
  }

  const handleAfterExecution = (widget, action) => {
    if(context.onAfterExecution){
      context.onAfterExecution(widget, action);
    }
  }

  const handleExecution = (widget, action) => {
    if(!action){
      return false;
    }

    handleBeforeExecution(widget, action);
    const type = action.type;
    switch(type) {
      case 'link': {
        return handleLinkAction(widget, action);
      }

      case 'pageAnchor': {
        return handlePageAnchorAction(interactiveContext, widget, action, widgetContext);
      }

      case 'widgetAnchor': {
        return handleWidgetAnchorAction(interactiveContext, action, widgetContext);
      }

      case 'asset': {
        return handleAssetAction(widget, action, contentContext);
      }
    }

    handleAfterExecution(widget, action);

    return false;
  }

  return state;
}

const handleLinkAction = (widget, action) => {
  if(!action){
    return false;
  }

  const {newTab, value} = action;
  const currentWindow = window.self || window;

  if(newTab){
    currentWindow.open(value);
  }else{
    currentWindow.location = value;
  }
}

const handlePageAnchorAction = (interactiveContext, widget, action, widgetContext) => {
  if(!action || !interactiveContext){
    return false;
  }

  const {value} = action;

  const storyboardType = _.get(widgetContext, 'storyboard.type', '');

  if (storyboardType === 'INTERACTIVE_CONTENT') {
    if (value || !_.has(action, 'value')) {
      interactiveContext.scrollToTop();
    } else {
      interactiveContext.scrollToBottom();
    }
  }

  if (storyboardType != 'INTERACTIVE_CONTENT') {
    if (value || !_.has(action, 'value')) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }
}

const handleWidgetAnchorAction = (interactiveContext, action, widgetContext) => {
  if (!action) {
    return false;
  }

  const storyboardType = _.get(widgetContext, 'storyboard.type', '');

  if (storyboardType === 'INTERACTIVE_CONTENT') {
    interactiveContext.scrollToWidget(action);
  } else {
    const { value } = action;
    var widgetElement = document.getElementById(value);
    widgetElement.scrollIntoView();
  }
}

const handleAssetAction = (widget, action, contentContext) => {
  if(!action){
    return false;
  }
  
  contentContext.viewContent(widget, action.value);
}
